import React from "react"
import PropTypes from "prop-types"
import { get } from "lodash"
import { CSSTransition } from "react-transition-group"
import { CellFooter, CellBody, Cells, Cell } from "react-weui"

import ModalCitySelector from "../components/ModalCitySelector"
import ModalTagSelector from "../components/ModalTagSelector"
import { cities, publicTagNames} from "../../../../data"

class SearchMenu extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      showCityDialog: false,
      showTypeDialog: false, 
    }
  }

  render() {
    const { city, tag, onToggleToday, forToday, onQuery } = this.props
    return (
      <React.Fragment>
        <Cells className="menu">
          <Cell access onClick={() => this.setState({showCityDialog: true})}>
            <CellBody>
              {get(cities, [city, "title"], "所有城市")}
            </CellBody>
            <CellFooter/>
          </Cell>
          <Cell access onClick={() => this.setState({showTypeDialog: true})}>
            <CellBody>
              {get(publicTagNames, [tag, "name"], "所有产品")}
            </CellBody>
            <CellFooter/>
          </Cell>
          <Cell onClick={() => onToggleToday()}>
            <CellBody>今天有空</CellBody>
            <CellFooter>
              <input
                checked={forToday}
                type="checkbox"
                className="weui-agree__checkbox"
              />
            </CellFooter>
          </Cell>
        </Cells>

        <CSSTransition
          in={this.state.showCityDialog}
          timeout={300}
          classNames="modal"
          unmountOnExit
        >
          {
            <ModalCitySelector
              city={city}
              onCity={city => {
                onQuery({ city })
                this.setState({ showCityDialog: false })
              }}
              onClose={() => this.setState({ showCityDialog: false })}
            />
          }
        </CSSTransition>
        <CSSTransition
          in={this.state.showTypeDialog}
          timeout={300}
          classNames="modal"
          unmountOnExit
        >
          {
            <ModalTagSelector
              selectedTag={tag}
              onTag={tag => {
                onQuery({ tag })
                this.setState({ showTypeDialog: false })
              }}
              onClose={() => this.setState({showTypeDialog: false})}
            />
          }
        </CSSTransition>
      </React.Fragment>
    )
  }
}

SearchMenu.propTypes = {
  city: PropTypes.string.isRequired, 
  tag: PropTypes.string.isRequired, 
  onToggleToday: PropTypes.func.isRequired, 
  forToday: PropTypes.bool.isRequired, 
  onQuery: PropTypes.func.isRequired,
}

export default SearchMenu



// WEBPACK FOOTER //
// ./src/app/catalogo/search/Search.Menu.jsx